import { Button as ButtonDaisy } from "react-daisyui";
import { twMerge } from "tailwind-merge";
import { getIconClass } from "./button.styles";
import type { ButtonProps } from "./button.types";

export const Button = ({
  children,
  icon,
  size = "md",
  iconPosition,
  className,
  disabled,
  iconClass,
  ...props
}: ButtonProps) => {
  const buttonClasses = twMerge("rounded-[28px]", disabled && "btn-disabled !text-white", className);
  const iconWrapperClass = getIconClass({ size, className: iconClass });
  return (
    <ButtonDaisy size={size} className={buttonClasses} {...props} disabled={disabled}>
      {icon && iconPosition === "start" ? <span className={iconWrapperClass}>{icon}</span> : null}
      {children}
      {icon && iconPosition === "end" ? <span className={iconWrapperClass}>{icon}</span> : null}
    </ButtonDaisy>
  );
};
